import React from "react";
import { connect } from "react-redux";
import { SuspendSpin } from "../lib/suspend-spin";
import { AudioUploadModalWrapper } from "./upload_modal_wrapper";
import EpisodeDeleteModalWrapper from "./episode_delete_modal_wrapper";
import AdPlacementsModalWrapper from "./ad_placements_modal_wrapper";
import ConfirmationModalWrapper from "./confirmation_modal_wrapper";
import ImportModalWrapper from "./import_modal_wrapper";
import ShowFormModalWrapper from "./show_form_modal_wrapper";
import EpisodeFormModalWrapper from "./episode_form_modal_wrapper";
import ShowRedirectHelpModalWrapper from "./show_redirect_help_modal_wrapper";
import ShowDeleteModalWrapper from "./show_delete_modal_wrapper";
import DistributionsModalWrapper from "./distributions_modal_wrapper";
import WelcomeModalWrapper from "./welcome_modal/welcome_modal_wrapper";
import PromotionsIntroModal from "./promotions_intro_modal";
import PromotionsOptInModal from "./promotions_opt_in_modal";
import DealCreateModal from "./deal_create_modal";
import DirectoryShowInvite from "./directory_show_invite";
import DealRequestModal from "./deal_request_modal";
import PostActionModal from "./post_action_modal";
import MonetizationIntroModal from "./monetization_intro_modal/monetization_intro_modal";
import SponsorModal from "./sponsorship_modal/sponsorship_modal";
import EnableSubscriptionModal from "./enable_subscriptions/enable_subscriptions";
import ListenOnModal from "./listen_on_modal";
import TipModal from "./tip_modal";
import { AudioBlockCreateModal } from "./audio_block_modal_parts/audio_block_modal";
import { AudioBlockEditModal } from "./audio_block_modal_parts/audio_block_modal";
import CampaignEditor from "./campaign_editor";
import CampaignPodcastSelectorModal from "./campaign_podcast_selector/campaign_podcast_selector_modal";
import CampaignPodcastScheduleModal from "./campaign_schedule_podcast/campaign_schedule_podcast";
import CampaignSummaryView from "./campaign_editor/campaign_summary_view";
import UploadInterimModal from "./upload_interim_modal/upload_interim_modal";
const SetEpisodeMarkersModal = React.lazy(() =>
  import("../pages/audio_management/set_episode_markers_modal")
);

export const UPLOAD_MEDIA_MODAL = "UPLOAD_MEDIA_MODAL";
export const EPISODE_DELETE_MODAL = "EPISODE_DELETE_MODAL";
export const AD_PLACEMENTS_MODAL = "AD_PLACEMENTS_MODAL";
export const CONFIRMATION_MODAL = "CONFIRMATION_MODAL";
export const IMPORT_MODAL = "IMPORT_MODAL";
export const SHOW_FORM_MODAL = "SHOW_FORM_MODAL";
export const EPISODE_FORM_MODAL = "EPISODE_FORM_MODAL";
export const SHOW_REDIRECT_HELP_MODAL = "SHOW_REDIRECT_HELP_MODAL";
export const DISTRIBUTIONS_MODAL = "DISTRIBUTIONS_MODAL";
export const SHOW_DELETE_MODAL = "SHOW_DELETE_MODAL";
export const WELCOME_MODAL = "WELCOME_MODAL";
export const PROMOTIONS_INTRO_MODAL = "PROMOTIONS_INTRO_MODAL";
export const PROMOTIONS_OPT_IN_MODAL = "PROMOTIONS_OPT_IN_MODAL";
export const DEAL_CREATE_MODAL = "DEAL_CREATE_MODAL";
export const INVITE_DIRECTORY_SHOW = "INVITE_DIRETORY_SHOW";
export const DEAL_REQUEST_MODAL = "DEAL_REQUEST_MODAL";
export const POST_ACTION_MODAL = "POST_ACTION_MODAL";
export const MONETIZATION_INTRO_MODAL = "MONETIZATION_INTRO_MODAL";
export const SPONSORSHIP_MODAL = "SPONSORSHIP_MODAL ";
export const ENABLE_SUBSCRIPTION_MODAL = "ENABLE_SUBSCRIPTION_MODAL";
export const LISTEN_ON_MODAL = "LISTEN_ON_MODAL";
export const TIP_MODAL = "TIP_MODAL";
export const AUDIO_BLOCK_CREATE_MODAL = "AUDIO_BLOCK_CREATE_MODAL";
export const AUDIO_BLOCK_EDIT_MODAL = "AUDIO_BLOCK_EDIT_MODAL";
export const CAMPAIGN_EDITOR_MODAL = "CAMPAIGN_EDITOR_MODAL";
export const SET_EPISODE_MARKERS_MODAL = "SET_EPISODE_MARKERS_MODAL";
export const CAMPAIGN_PODCAST_SELECTOR = "CAMPAIGN_PODCAST_SELECTOR";
export const CAMPAIGN_PODCAST_SCHEDULE = "CAMPAIGN_PODCAST_SCHEDULE";
export const CAMPAIGN_SUMMARY_VIEW = "CAMPAIGN_SUMMARY_VIEW";
export const UPLOAD_INTERIM = "UPLOAD_INTERIM";

const MODAL_COMPONENTS = {
  [UPLOAD_MEDIA_MODAL]: props => <AudioUploadModalWrapper {...props} />,
  [EPISODE_DELETE_MODAL]: props => <EpisodeDeleteModalWrapper {...props} />,
  [SHOW_DELETE_MODAL]: props => <ShowDeleteModalWrapper {...props} />,
  [AD_PLACEMENTS_MODAL]: props => <AdPlacementsModalWrapper {...props} />,
  [CONFIRMATION_MODAL]: props => <ConfirmationModalWrapper {...props} />,
  [IMPORT_MODAL]: props => <ImportModalWrapper {...props} />,
  [SHOW_FORM_MODAL]: props => <ShowFormModalWrapper {...props} />,
  [EPISODE_FORM_MODAL]: props => <EpisodeFormModalWrapper {...props} />,
  [SHOW_REDIRECT_HELP_MODAL]: props => <ShowRedirectHelpModalWrapper {...props} />,
  [DISTRIBUTIONS_MODAL]: props => <DistributionsModalWrapper {...props} />,
  [WELCOME_MODAL]: props => <WelcomeModalWrapper {...props} />,
  [PROMOTIONS_INTRO_MODAL]: props => <PromotionsIntroModal {...props} />,
  [PROMOTIONS_OPT_IN_MODAL]: props => <PromotionsOptInModal {...props} />,
  [DEAL_CREATE_MODAL]: props => <DealCreateModal {...props} />,
  [DEAL_REQUEST_MODAL]: props => <DealRequestModal {...props} />,
  [INVITE_DIRECTORY_SHOW]: props => <DirectoryShowInvite {...props} />,
  [POST_ACTION_MODAL]: props => <PostActionModal {...props} />,
  [MONETIZATION_INTRO_MODAL]: props => <MonetizationIntroModal {...props} />,
  [SPONSORSHIP_MODAL]: props => <SponsorModal {...props} />,
  [ENABLE_SUBSCRIPTION_MODAL]: props => <EnableSubscriptionModal {...props} />,
  [LISTEN_ON_MODAL]: props => <ListenOnModal {...props} />,
  [TIP_MODAL]: props => <TipModal {...props} />,
  [AUDIO_BLOCK_CREATE_MODAL]: props => <AudioBlockCreateModal {...props} />,
  [AUDIO_BLOCK_EDIT_MODAL]: props => <AudioBlockEditModal {...props} />,
  [SET_EPISODE_MARKERS_MODAL]: props => (
    <SuspendSpin>
      <SetEpisodeMarkersModal {...props} />
    </SuspendSpin>
  ),
  [CAMPAIGN_EDITOR_MODAL]: props => <CampaignEditor {...props} />,
  [CAMPAIGN_PODCAST_SELECTOR]: props => <CampaignPodcastSelectorModal {...props} />,
  [CAMPAIGN_PODCAST_SCHEDULE]: props => <CampaignPodcastScheduleModal {...props} />,
  [CAMPAIGN_SUMMARY_VIEW]: props => <CampaignSummaryView {...props} />,
  [UPLOAD_INTERIM]: props => <UploadInterimModal {...props} />,
};

const ModalRoot = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal {...modalProps} />;
};

export default connect(state => state.modal)(ModalRoot);
